import React, { Fragment, useEffect, useState, useRef } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import stylesAlert from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';
import { Assignment, Search } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import {
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import SweetAlert from 'react-bootstrap-sweetalert';

import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import moment from 'moment';
import { wsGetAll, wsFindBy, wsCreate, wsPost } from 'services/WService';
import ModalFilterCustomer from './ModalFilterCustomer';
import ModalFilterProduct from './ModalFilterProduct';
import ResponseData from './ResponseData';
import { nPercent } from 'hooks/Pipe';
import NewSaleInvoiceDetails from './NewSaleInvoiceDetails';
import NewSaleConceptDetails from './NewSaleConceptDetails';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

const useStyles = makeStyles({
  ...styles,
  ...stylesAlert,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold',
  },
  table: {
    minWidth: 1300,
  },
  totals: {
    '& td': {
      fontWeight: '500',
    },
  },
  subHeader: {
    '& td': {
      height: '60px',
      paddingTop: '0',
      paddingBottom: '0',
    },
  },
});

const dataSaleDefault = {
  base_canal_id: 1,
  base_payment_term_id: 1,
  base_document_type_id: 2,
  base_reason_id_priority: 9,
};

export default WithApp(function NewSale(props) {
  const classes = useStyles();

  const formNewSale = useRef(null);

  const [notify, showNotify] = useToasty(); //notificación despues de las
  const [clear, setClear] = useState(false);
  const [processing, setProcessing] = useState(false);

  const [openModalCustomer, setOpenModalCustomer] = useState(false); //Abrir modal
  const [openModalProduct, setOpenModalProduct] = useState(false); //Abrir modal
  const [process, setProcess] = useState(false); //deshabilita todo la cabecera si se procesa la venta

  const [dataSale, setDataSale] = useState(dataSaleDefault);
  const [productSelects, setProductSelects] = useState([]);
  const [total, setTotal] = useState({});
  const [products, setProducts] = useState([]);
  const [productSelected, setProductSelected] = useState({
    digitate_packages: 0,
    digitate_units: 0,
  });
  const [paymentTerm, setPaymentTerm] = useState({});

  const [saleType, setSaleType] = useState('O');
  const [deliveryType, setDeliveryType] = useState('D');

  //info despues de ser procesada (enviada)
  const [responseData, setResponseData] = useState({ order: {}, details: [] });
  const [DocType, setDocType] = useState('I');

  //#region funciones de traer datas
  const [zones, setZones] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [docTypes, setDocTypes] = useState([]);
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [canals, setCanals] = useState([]);
  const [reasons, setReasons] = useState([]);

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listSeller(zoneId, saleType) {
    let response = await wsFindBy('base/seller', { base_zone_id: zoneId, seller_type: saleType });
    if (response.success) {
      if (saleType === 'O') {
        if (response.data?.length > 0) {
          const {
            base_business_partner_id,
            CardName,
            base_address_id,
            Address2,
            base_customer_route_id,
            ...rest
          } = dataSale;
          setDataSale({
            ...rest,
            sale_type: saleType,
            base_zone_id: zoneId,
            base_seller_id: response.data[0].id,
            SlpName: response.data[0].SlpName,
          });
        } else {
          showNotify('Esta zona no tiene vendedor asignado', 'info');
        }
      } else {
        setSellers(response.data);
      }
    }
  }

  async function listDocTypes() {
    let response = await wsGetAll('base/document-type');
    if (response.success) setDocTypes(response.data);
  }

  async function listPaymentTerms() {
    let response = await wsGetAll('base/payment-term');
    if (response.success) {
      setPaymentTerms(response.data);
      setPaymentTerm(response.data.find((item) => item.id == 1));
    }
  }

  async function listCanals() {
    let response = await wsGetAll('base/canal');
    if (response.success) setCanals(response.data);
  }

  async function listReasons() {
    let response = await wsFindBy('base/reason', 'group', '3');
    if (response.success) setReasons(response.data);
  }

  //#endregion

  //#region funciones complementarias de procesos internos
  const handleChangeSale = (e) => {
    if (e.target.name === 'sale_type') {
      setDataSale({ ...dataSaleDefault, [e.target.name]: e.target.value });
    } else if (e.target.name === 'base_zone_id') {
      const {
        base_business_partner_id,
        CardName,
        base_address_id,
        Address2,
        base_customer_route_id,
        base_seller_id,
        SlpName,
        ...rest
      } = dataSale;
      setDataSale({ ...rest, [e.target.name]: e.target.value });
    } else {
      setDataSale({ ...dataSale, [e.target.name]: e.target.value });
    }
  };

  function deleteRow(id) {
    productSelects.splice(
      productSelects.findIndex((x) => x.id == id),
      1,
    );
    setProductSelects([...productSelects]);
    calcTotals(productSelects);
  }

  function calcImport(obj) {
    let digitate_packages = obj.digitate_packages || 0;
    let NumInSale = obj.NumInSale || 0;
    let digitate_units = obj.digitate_units || 0;

    const interest =
      paymentTerm.interest_rate > 0 ? 1 + parseFloat(paymentTerm.interest_rate || 0) / 100 : 0;

    const unitPrice = paymentTerm.interest_rate > 0 ? obj.unit_price * interest : obj.unit_price;

    const packagePrice =
      paymentTerm.interest_rate > 0 ? obj.package_price * interest : obj.package_price;

    let data =
      digitate_packages * NumInSale * (dataSale.base_canal_id == 1 ? unitPrice : packagePrice) +
      digitate_units * unitPrice;
    return data || 0;
  }

  useEffect(() => {
    // TODO?solo se ejecuta cuando se cambia la lista de precio

    if (productSelects?.length > 0) {
      productSelects.map((item) => (item.import = calcImport(item)));
      setProductSelects([...productSelects]);
      calcTotals(productSelects);
    }
  }, [dataSale.base_canal_id, dataSale.base_payment_term_id]);

  const handleChangeRow = (e, id) => {
    //actualizando las propiedades de cantidades.
    if (id !== undefined) {
      let objIndex = productSelects.findIndex((obj) => obj.id == id);
      productSelects[objIndex][e.target.name] = parseInt(e.target.value);
    }

    productSelects.map((item) => {
      let obj = calculator(item);
      if (item.id === id) {
        item.import = calcImport(item);
        item.digitate_packages = obj.digitate_packages;
        item.digitate_units = obj.digitate_units;
      }
    });
    setProductSelects([...productSelects]);
    calcTotals(productSelects);
  };

  function calculator(obj, position) {
    let pack = (obj.digitate_packages || 0) + (obj.digitate_units || 0) / obj.NumInSale;
    let residue = obj.digitate_units % obj.NumInSale;
    let objUpdate = {
      digitate_packages: parseInt(pack || 0),
      digitate_units: residue || 0,
    };
    if (position === 'Header') {
      setProductSelected({ ...obj, ...objUpdate });
    }
    return objUpdate;
  }

  function calcTotals(productSelects) {
    let digitate_packages = 0;
    let digitate_units = 0;
    let importe = 0;
    for (let obj of productSelects) {
      digitate_packages += parseFloat(obj.digitate_packages || 0);
      digitate_units += parseFloat(obj.digitate_units || 0);
      importe += parseFloat(obj.import);
    }
    setTotal({
      digitate_packages: digitate_packages,
      digitate_units: digitate_units,
      import: importe,
    });
  }

  function clearData() {
    setDataSale(dataSaleDefault);
    setSaleType('O');
    setDeliveryType('D');
    setTotal({});
    setProductSelects([]);
    setProductSelected({});
    setClear(!clear);
    setProcess(false);
    setResponseData({});
    setPaymentTerm({});
  }

  //#endregion

  //#region --- funcion para mostrar alert de confirmacion al cambiar zona
  const [alert, setAlert] = useState(null);
  const [alertAprobed, setAlertAprobed] = useState(null);

  const hideAlert = () => {
    setAlert(null);
  };
  function confirmChange(callback) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Está seguro de realizar este cambio?"
        onConfirm={() => {
          callback();
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
        closeOnClickOutside={false}
      >
        Esta acción eliminará los productos elegidos
      </SweetAlert>,
    );
  }
  //#endregion

  async function getProduct(code) {
    let filter = undefined;
    if (saleType === 'S') {
      filter = {
        ItemCode: code,
        base_customer_route_id: dataSale.base_customer_route_id,
        base_seller_id: dataSale.base_seller_id,
      };
    }
    let response = await wsFindBy(
      saleType === 'O' ? `base/zone/${dataSale.base_zone_id}/products` : 'base/seller/products',
      saleType === 'S' ? filter : { ItemCode: code },
    );
    if (response.success) {
      setProducts(response.data);
    } else {
      showNotify('No se encontró el producto', 'info');
      setProductSelected({});
      setProducts([]);
    }
  }

  function addProductCheck(item, importe) {
    if ((item.TreeType === 'N' && item.Aviable > 0) || item.TreeType !== 'N') {
      let arrArticlesSelected = [...productSelects];
      arrArticlesSelected.unshift({ ...item, import: importe });
      calcTotals(arrArticlesSelected);
      setProductSelects(arrArticlesSelected);
      setProductSelected({});
      setProducts([]);
    } else {
      showNotify('No hay stock disponible', 'info');
    }
  }

  async function saveSale() {
    let newProductSelects = [];
    for (let obj of productSelects) {
      newProductSelects.push({
        logi_product_id: obj.id,
        digitate_packages: parseInt(obj.digitate_packages || 0),
        digitate_units: parseInt(obj.digitate_units || 0),
        units_package: parseInt(obj.NumInSale),
        digitate_units_price: obj.unit_price,
        digitate_package_price: obj.package_price,
        digitate_amount: obj.import,
        total_units: 0,
      });
    }

    if (total.digitate_packages < 1 && total.digitate_units < 1) {
      showNotify('Ingrese cantidades de paquetes y unidades válidas', 'info');
      return;
    }

    let data = {
      order: {
        DocType: 'I',
        base_address_id: dataSale.base_address_id,
        base_business_partner_id: dataSale.base_business_partner_id,
        base_canal_id: dataSale.base_canal_id,
        base_document_type_id: dataSale.base_document_type_id,
        base_payment_term_id: dataSale.base_payment_term_id,
        base_reason_id_priority: dataSale.base_reason_id_priority,
        base_seller_id: dataSale.base_seller_id,
        base_zone_id: dataSale.base_zone_id,
        sale_type: dataSale.sale_type,
        delivery_type: deliveryType,
        digitate_discount: dataSale.digitate_discount,
        digitate_gross_amount: '0',
        digitate_total_amount: '0',
        comment: dataSale.comment,
      },
      details: newProductSelects.reverse(),
    };

    for (let key in data.order) {
      if (data.order[key] == undefined || data.order[key] == '') {
        delete data.order[key];
      }
    }

    setProcessing(true);

    let entity = saleType === 'O' || deliveryType === 'O' ? 'sale/order' : 'ordm/order/web';

    let response = await wsCreate(entity, data);
    if (response.success) {
      let responseData = response.data.details.map((item) => {
        return { ...item, units_package: 0, diference_units: 0 };
      });
      let promo = responseData.filter((item) => item.type == 'B');
      let arrMerge = [];
      for (let i = 0; i < responseData.length; i++) {
        if (responseData[i].type == 'N') {
          for (let objSend of data.details) {
            if (objSend.logi_product_id == responseData[i].logi_product_id) {
              arrMerge.push({
                ...responseData[i],
                units_package: objSend.units_package,
                diference_units:
                  objSend.units_package * objSend.digitate_packages +
                  objSend.digitate_units -
                  (objSend.units_package * parseInt(responseData[i].packages) +
                    parseInt(responseData[i].units)),
              });
            }
          }
        }
      }
      setResponseData({ order: response.data.order, details: [...arrMerge, ...promo] });
      showNotify(response.message);
      setProcess(true);
    } else {
      showNotify(response.message, 'error');
    }
    setProcessing(false);
  }

  async function saveConceptSale(concepts) {
    let data = {
      order: {
        DocType: 'S',
        base_address_id: dataSale.base_address_id,
        base_business_partner_id: dataSale.base_business_partner_id,
        base_canal_id: dataSale.base_canal_id,
        base_document_type_id: dataSale.base_document_type_id,
        base_payment_term_id: dataSale.base_payment_term_id,
        base_reason_id_priority: dataSale.base_reason_id_priority,
        base_seller_id: dataSale.base_seller_id,
        base_zone_id: dataSale.base_zone_id,
        sale_type: dataSale.sale_type,
        delivery_type: deliveryType,
        digitate_discount: dataSale.digitate_discount,
        digitate_gross_amount: '0',
        digitate_total_amount: '0',
        comment: dataSale.comment,
      },
      concepts: concepts,
    };

    setProcessing(true);
    let response = await wsCreate('sale/order', data);
    if (response.success) {
      showNotify(response.message);
      setProcess(true);
      setResponseData({ order: response.data.order });
    } else {
      showNotify(response.message, 'error');
    }
    setProcessing(false);
  }

  function continuar() {
    clearData();
    listPaymentTerms();
  }

  async function approveOrCancel(status, data = undefined) {
    let response = await wsPost(
      `ordm/order/${responseData.order.id}/${status ? 'approve' : 'annular'}`,
      data === undefined ? '' : data,
    );
    if (response.success) {
      showNotify(response.message);
      clearData();
      listPaymentTerms();
    } else {
      showNotify(response.message, 'error');
    }
    return response;
  }

  async function updateOrder() {
    let response = await wsPost('ordm/order/' + responseData.order.id + '/annular', {
      state: 'E',
      ObservacionError: 'Editar',
    });
    if (response.success) {
      setProcess(false);
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    listZones();
    listDocTypes();
    listPaymentTerms();
    listCanals();
    listReasons();
  }, []);

  // Cambiando el canal a minorista para ventas de oficina
  useEffect(() => {
    if (saleType === 'O') {
      setDeliveryType('D');
      setDataSale((sale) => ({ ...sale, base_canal_id: 1 }));
    }
  }, [saleType]);

  return (
    <Fragment>
      {alert}
      {alertAprobed}
      <AllowedGuard
        permission={ConstantPermissions.SALE_ORDERS_WAREHOUSEAUDITOR_INDEX}
        component={
          <ModalFilterCustomer
            open={openModalCustomer}
            deliveryType={deliveryType}
            setOpen={setOpenModalCustomer}
            dataSale={dataSale}
            changeDataSale={setDataSale}
            saleType={saleType}
            zones={zones}
            zoneId={dataSale.base_zone_id}
            extraFilters={undefined}
          />
        }
      >
        <ModalFilterCustomer
          open={openModalCustomer}
          deliveryType={deliveryType}
          setOpen={setOpenModalCustomer}
          dataSale={dataSale}
          changeDataSale={setDataSale}
          saleType={saleType}
          zones={zones}
          zoneId={dataSale.base_zone_id}
          extraFilters={{ firstLetterRestriction: ['E', 'S'] }}
        />
      </AllowedGuard>
      <ModalFilterProduct
        saleType={saleType}
        deliveryType={deliveryType}
        open={openModalProduct}
        setOpen={setOpenModalProduct}
        dataSale={dataSale}
        productSelects={productSelects}
        setProductSelects={setProductSelects}
        handleChangeRow={handleChangeRow}
        addProductCheck={addProductCheck}
        calcImport={calcImport}
        calcTotals={calcTotals}
        deleteRow={deleteRow}
      />
      <Toasty action={notify} />
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Datos Generales</h4>
        </CardHeader>
        <CardBody>
          <form
            ref={formNewSale}
            id="formNewSale"
            onSubmit={(e) => {
              e.preventDefault();
              saveSale();
            }}
          >
            <GridContainer>
              {/* Tipo venta */}
              <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                <FormControl fullWidth margin="normal" size="small" required>
                  <InputLabel>Tipo venta</InputLabel>
                  <Select
                    value={saleType || ''}
                    inputProps={{
                      name: 'sale_type',
                      readOnly: process,
                    }}
                    disabled={DocType === 'S'}
                    onChange={(e) => {
                      if (productSelects.length > 0) {
                        confirmChange(() => {
                          handleChangeSale(e);
                          setSaleType(e.target.value);
                          setProductSelects([]);
                          calcTotals([]);
                        });
                      } else {
                        handleChangeSale(e);
                        setSaleType(e.target.value);
                        setProductSelects([]);
                        calcTotals([]);
                      }
                    }}
                  >
                    <MenuItem value="O">Oficina</MenuItem>
                    <MenuItem value="S">Campo</MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
              {/* DocType */}
              <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                <FormControl fullWidth margin="normal" size="small" required>
                  <InputLabel>Tipo</InputLabel>
                  <Select
                    value={DocType}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value === 'S') {
                        setSaleType('O');
                        setProductSelects([]);
                        calcTotals([]);
                      }
                      setDocType(e.target.value);
                    }}
                  >
                    <MenuItem value="I">Venta</MenuItem>
                    <MenuItem value="S">Concepto</MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
              {/* Envío */}
              {DocType === 'I' && (
                <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel>Envío</InputLabel>
                    <Select
                      value={deliveryType}
                      disabled={saleType === 'O'}
                      onChange={(e) => setDeliveryType(e.target.value)}
                    >
                      <MenuItem value="D">Domicilio</MenuItem>
                      <MenuItem value="O">Recojo en oficina</MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {/* Fecha Inicio */}
              <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                <TextField
                  label="Fecha inicio"
                  type="date"
                  name="start_date"
                  value={moment().format('YYYY-MM-DD')}
                  margin="normal"
                  size="small"
                  inputProps={{
                    min: moment().format('YYYY-MM-DD'),
                    readOnly: true,
                  }}
                  fullWidth
                />
              </GridItem>
              {/* Fecha Final */}
              <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                <TextField
                  label="Fecha final"
                  type="date"
                  name="end_date"
                  value={moment().format('YYYY-MM-DD')}
                  margin="normal"
                  size="small"
                  inputProps={{
                    min: moment().format('YYYY-MM-DD'),
                    readOnly: true,
                  }}
                  fullWidth
                />
              </GridItem>
              {/* Zona */}
              <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                <FormControl fullWidth margin="normal" size="small" required>
                  <InputLabel>Zona</InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    value={dataSale.base_zone_id || ''}
                    inputProps={{
                      name: 'base_zone_id',
                      readOnly: process,
                    }}
                    onChange={(e) => {
                      if (productSelects.length > 0) {
                        confirmChange(() => {
                          if (saleType === 'S') handleChangeSale(e);
                          listSeller(e.target.value, saleType);
                          setProductSelects([]);
                          calcTotals([]);
                        });
                      } else {
                        if (saleType === 'S') handleChangeSale(e);
                        listSeller(e.target.value, saleType);
                        setProductSelected({});
                      }
                    }}
                  >
                    {zones.map((item, i) => {
                      return (
                        <MenuItem value={item.id} key={i}>
                          {item.description}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                {saleType === 'S' ? (
                  <Autocomplete
                    key={dataSale.base_zone_id}
                    options={sellers}
                    disableClearable
                    getOptionLabel={(option) =>
                      option.seller_type === 'O'
                        ? 'Oficina' + ' - ' + option.SlpName
                        : 'Campo' + ' - ' + option.SlpName
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Vendedor"
                        margin="normal"
                        size="small"
                        required
                      />
                    )}
                    noOptionsText="Sin datos"
                    onChange={(e, item) => {
                      const {
                        base_business_partner_id,
                        CardName,
                        base_address_id,
                        Address2,
                        base_customer_route_id,
                        ...rest
                      } = dataSale;
                      setDataSale({ ...rest, base_seller_id: item.id });
                      setProductSelected({});
                    }}
                    disabled={process}
                  />
                ) : (
                  <TextField
                    label="Vendedor"
                    margin="normal"
                    value={dataSale.SlpName || ''}
                    size="small"
                    fullWidth
                    inputProps={{ readOnly: true }}
                    required
                    disabled={process}
                  />
                )}
              </GridItem>
              <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                <AllowedGuard
                  permission={ConstantPermissions.SALE_ORDERS_WAREHOUSEAUDITOR_INDEX}
                  component={
                    <TextField
                      key={dataSale.base_seller_id + openModalCustomer + dataSale.base_zone_id}
                      label="Cliente"
                      value={dataSale.CardName || ''}
                      margin="normal"
                      size="small"
                      inputProps={{ readOnly: true }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            style={{ cursor: 'pointer', color: '#07c107' }}
                            onClick={() => {
                              setOpenModalCustomer(true);
                            }}
                            position="start"
                            disablePointerEvents={
                              !!dataSale.base_seller_id && !process ? false : true
                            }
                          >
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                    />
                  }
                >
                  <TextField
                    key={dataSale.base_seller_id + openModalCustomer + dataSale.base_zone_id}
                    label="Cliente"
                    value={dataSale.CardName || ''}
                    margin="normal"
                    size="small"
                    inputProps={{ readOnly: true }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          style={{ cursor: 'pointer', color: '#07c107' }}
                          onClick={() => {
                            setOpenModalCustomer(true);
                          }}
                          position="start"
                          disablePointerEvents={
                            !!dataSale.base_seller_id && !process ? false : true
                          }
                        >
                          <Search />
                        </InputAdornment>
                      ),
                    }}
                    fullWidth
                  />
                </AllowedGuard>
              </GridItem>
              <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                <TextField
                  key={dataSale.base_seller_id + openModalCustomer + dataSale.base_zone_id}
                  label="Dirección"
                  value={
                    deliveryType === 'O' && dataSale.base_zone_id !== undefined
                      ? zones.find((zone) => zone.id === parseInt(dataSale.base_zone_id))
                          ?.sunat_establishment_address || ''
                      : dataSale.Address2 || ''
                  }
                  margin="normal"
                  size="small"
                  inputProps={{ readOnly: true }}
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                <FormControl fullWidth margin="normal" size="small" required>
                  <InputLabel>Tipo documento</InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    value={dataSale.base_document_type_id || ''}
                    inputProps={{
                      name: 'base_document_type_id',
                      readOnly: process,
                    }}
                    onChange={handleChangeSale}
                  >
                    {docTypes.map((item, i) => {
                      return (
                        <MenuItem value={item.id} key={i}>
                          {item.description_short}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                <FormControl fullWidth margin="normal" size="small" required>
                  <InputLabel>Término de pago</InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    value={dataSale.base_payment_term_id || ''}
                    inputProps={{
                      name: 'base_payment_term_id',
                      readOnly: process,
                    }}
                    onChange={handleChangeSale}
                  >
                    {paymentTerms.map((item, i) => {
                      return (
                        <MenuItem value={item.id} key={i} onClick={() => setPaymentTerm(item)}>
                          {item.PymntGroup}
                          {item.interest_rate === null
                            ? ''
                            : item.interest_rate > 0
                            ? ` (${nPercent(item.interest_rate) || ''})`
                            : ''}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                <FormControl fullWidth margin="normal" size="small" required>
                  <InputLabel>Canal</InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    disabled={saleType === 'O'}
                    value={dataSale.base_canal_id || ''}
                    inputProps={{
                      name: 'base_canal_id',
                      readOnly: process,
                    }}
                    onChange={handleChangeSale}
                  >
                    {canals.map((item, i) => {
                      return (
                        <MenuItem value={item.id} key={i}>
                          {item.description}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={6} md={4} lg={2} xl={2}>
                <TextField
                  label="% Descuento"
                  name="digitate_discount"
                  type="number"
                  value={dataSale.digitate_discount || ''}
                  onChange={handleChangeSale}
                  inputProps={{ readOnly: process }}
                  fullWidth
                  margin="normal"
                  size="small"
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={4} lg={2} xl={1}>
                <TextField
                  label="Monto bruto"
                  // name="digitate_gross_amount"
                  inputProps={{ readOnly: true }}
                  value={parseFloat(total.import || 0).toFixed(2)}
                  fullWidth
                  margin="normal"
                  size="small"
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={4} lg={2} xl={1}>
                <TextField
                  label="Total"
                  // name="digitate_total_amount"
                  inputProps={{ readOnly: true }}
                  value={(
                    total.import - (parseFloat(dataSale.digitate_discount) * total?.import) / 100 ||
                    0
                  ).toFixed(2)}
                  fullWidth
                  margin="normal"
                  size="small"
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={4} lg={2}>
                <FormControl fullWidth margin="normal" size="small" required>
                  <InputLabel>Razón prioridad</InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    value={dataSale.base_reason_id_priority || ''}
                    inputProps={{
                      name: 'base_reason_id_priority',
                      readOnly: process,
                    }}
                  >
                    {reasons.map((item, i) => {
                      return (
                        <MenuItem value={item.id} key={i}>
                          {item.description}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={6} md={4} lg={2}>
                <TextField
                  multiline
                  label="Comentario"
                  fullWidth
                  name="comment"
                  margin="normal"
                  size="small"
                  value={dataSale.comment || ''}
                  onChange={handleChangeSale}
                  inputProps={{ readOnly: process }}
                />
              </GridItem>
            </GridContainer>
          </form>
        </CardBody>
      </Card>

      {DocType === 'I' && (
        <NewSaleInvoiceDetails
          classes={classes}
          productSelects={productSelects}
          dataSale={dataSale}
          total={total}
          paymentTerm={paymentTerm}
          productSelected={productSelected}
          setProductSelected={setProductSelected}
          getProduct={getProduct}
          products={products}
          setProducts={setProducts}
          deleteRow={deleteRow}
          showNotify={showNotify}
          calcImport={calcImport}
          calculator={calculator}
          process={process}
          processing={processing}
          openModalProduct={openModalProduct}
          setOpenModalProduct={setOpenModalProduct}
          handleChangeRow={handleChangeRow}
          addProductCheck={addProductCheck}
          responseData={responseData}
          setAlertAprobed={setAlertAprobed}
          approveOrCancel={approveOrCancel}
          continuar={continuar}
          updateOrder={updateOrder}
        />
      )}

      {DocType === 'S' && (
        <NewSaleConceptDetails
          process={process}
          classes={classes}
          processing={processing}
          dataSale={dataSale}
          saveConceptSale={saveConceptSale}
          updateOrder={updateOrder}
          approveOrCancel={approveOrCancel}
          setAlertAprobed={setAlertAprobed}
        />
      )}
    </Fragment>
  );
});
